import { Permission } from '@cims-online/shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { AsphaltMixDesign } from '../AsphaltMixDesignsContext/types'
import { useAsphaltMixDesignsContext } from '../AsphaltMixDesignsContext'

export function useCreate(): CreateHeaderActionOptions<AsphaltMixDesign> {
  const {
    createModal: { toggle },
  } = useAsphaltMixDesignsContext()
  return {
    entity: 'Asphalt Mix Design',
    permission: Permission.CreateAsphaltMixDesign,
    modal: { type: 'custom', toggle },
  }
}
